import React from "react";

export default function WhatsAppButton() {
  const phoneNumber = "233508499531"; // WhatsApp Business number
  const message = "Hello, I am interested in your GPS tracking services.";
  const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 bg-green-500 text-white p-4 rounded-full shadow-lg hover:bg-green-600 transition transform hover:scale-110"
      title="Chat with us on WhatsApp"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="white"
        viewBox="0 0 24 24"
        width="28"
        height="28"
      >
        <path d="M20.52 3.48A11.825 11.825 0 0012 0C5.373 0 0 5.373 0 12c0 2.112.555 4.09 1.517 5.83L0 24l6.42-1.502A11.94 11.94 0 0012 24c6.627 0 12-5.373 12-12 0-3.205-1.244-6.224-3.48-8.52zm-8.52 19.02a9.931 9.931 0 01-5.154-1.44l-.367-.218-3.817.894.9-3.718-.23-.375A9.957 9.957 0 012 12c0-5.523 4.477-10 10-10s10 4.477 10 10-4.477 10-10 10zm5.17-7.828c-.29-.145-1.717-.846-1.983-.943-.266-.097-.46-.145-.654.145-.193.29-.747.943-.914 1.138-.167.193-.334.218-.624.073-.29-.145-1.223-.451-2.33-1.441-.861-.767-1.441-1.712-1.61-2.002-.167-.29-.018-.447.127-.592.13-.129.29-.334.434-.501.145-.167.193-.29.29-.483.097-.193.048-.362-.024-.507-.073-.145-.654-1.578-.895-2.168-.236-.567-.476-.49-.654-.5l-.557-.01c-.193 0-.507.073-.773.362s-1.015.992-1.015 2.418c0 1.425 1.038 2.803 1.183 2.993.145.193 2.04 3.108 4.943 4.358.692.298 1.23.476 1.65.611.693.22 1.326.189 1.826.115.557-.084 1.717-.698 1.957-1.372.24-.674.24-1.251.167-1.372-.072-.121-.264-.193-.555-.338z" />
      </svg>
    </a>
  );
}
